// Componente para input de senha com toggle de visibilidade
import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import style from "../signin.module.css";

/**
 * Componente PasswordInput - Input de senha com toggle de visibilidade
 * @param {Object} props - Propriedades do componente
 * @param {string} props.value - Valor do input
 * @param {Function} props.onChange - Handler de mudança
 * @param {boolean} props.showPassword - Se a senha está visível
 * @param {Function} props.onToggle - Handler para toggle de visibilidade
 * @param {string} props.error - Mensagem de erro (opcional)
 * @returns {JSX.Element} Input de senha com ícone de visibilidade
 */
const PasswordInput = ({ value, onChange, showPassword, onToggle, error }) => {
  return (
    <>
      <div className={style["input-field"]}>
        <p>
          Senha <span className={style["required"]}>*</span>
        </p>
        <div>
          <input
            className={style["inputs-password"]}
            type={showPassword ? "text" : "password"}
            name="password"
            id="password"
            placeholder="senha"
            value={value}
            onChange={onChange}
          />
          {/* Ícone para mostrar/ocultar senha */}
          {showPassword ? (
            <VisibilityOffIcon
              onClick={onToggle}
              className={style["icons-pass"]}
            />
          ) : (
            <VisibilityIcon
              onClick={onToggle}
              className={style["icons-pass"]}
            />
          )}
        </div>
        <div className={style.underline}></div>
      </div>

      {/* Mensagem de erro de validação */}
      {error && (
        <p style={{ display: "block", color: "red", marginTop: "10px" }}>
          {error}
        </p>
      )}
    </>
  );
};

export default PasswordInput;

